import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOnBoardingID, getOnBoardingMap } from '../redux/onBoarding/selector';
import { PublicRoutes } from '../routes/navigation';
import { OnBoardingMap, OnBoardingStepType, OnBoardingTypes } from '../redux/onBoarding/types';
import { addSteps, setCurrentStep } from '../redux/onBoarding/reducer';
import { useIonRouter } from '@ionic/react';

const getDataFromMap = (mapData: OnBoardingMap[], currentStep: OnBoardingStepType): OnBoardingMap | null => {
  let result = null;
  const iter = (s: OnBoardingMap) => {
    if (s.type === currentStep.type && s.id === currentStep.id) {
      result = s;
      return true;
    }

    if (s?.answers?.length) {
      return s.answers.forEach((a) => a.next_steps?.some(iter));
    }

    if (s?.next_steps?.length) {
      return s.next_steps.some(iter);
    }
  };

  mapData.some(iter);

  return result;
};

const useOnBoardingCurrentStep = (params: { id: string; type: OnBoardingTypes; boardId: string }) => {
  const { id, type, boardId } = params;
  const dispatch = useDispatch();

  const router = useIonRouter();

  //const nextStep = useSelector(getNextStep);
  const onBoardingId = useSelector(getOnBoardingID);
  const onBoardingMap = useSelector(getOnBoardingMap);

  const setCurrentStepAction = useCallback(() => {
    if (!onBoardingId) {
      router.push(`${PublicRoutes.ON_BOARDING.replace(':boardId', boardId)}`);
      return;
    }

    const currentMap = getDataFromMap(onBoardingMap, { type, id });
    if (!currentMap) {
      dispatch(setCurrentStep(null));
      return;
    }

    dispatch(setCurrentStep(currentMap));

    if (currentMap?.next_steps?.length) {
      dispatch(
        addSteps({
          nextSteps: currentMap.next_steps.map((s) => ({
            id: s.id,
            type: s.type,
          })),
          currentStep: { id: currentMap.id, type: currentMap.type },
        })
      );
    }
  }, [onBoardingMap, onBoardingId, type, id, dispatch]);

  return setCurrentStepAction;
};

export default useOnBoardingCurrentStep;
